import { createContext, useContext, useState } from "react";

interface AgentContextType {
    agent: Thread.AgentId;
    setAgent: (agent: Thread.AgentId) => void;
    threadId: string;
    setThreadId: (threadId: string) => void;
    selectedThreadId: string | null;
    setSelectedThreadId: (selectedThreadId: string | null) => void;
    onStartNewThread: () => void;
    onThreadSelect: (thread: Thread.Data) => void;
    showWelcomeMessage: boolean;
    setShowWelcomeMessage: (showWelcomeMessage: boolean) => void;
}

const AgentContext = createContext<AgentContextType>({
    agent: "research",
    setAgent: () => {},
    threadId: "",
    setThreadId: () => {},
    selectedThreadId: "",
    setSelectedThreadId: () => {},
    onStartNewThread: () => {},
    onThreadSelect: () => {},
    showWelcomeMessage: true,
    setShowWelcomeMessage: () => {},
});

export const AgentProvider = ({ children }: { children: React.ReactNode }) => {
    const [agent, setAgent] = useState<Thread.AgentId>("research");
    const [threadId, setThreadId] = useState<string>(crypto.randomUUID());
    const [selectedThreadId, setSelectedThreadId] = useState<string | null>(null);
    const [showWelcomeMessage, setShowWelcomeMessage] = useState(true);

    const onStartNewThread = () => {
        const newThreadId = crypto.randomUUID();
        setSelectedThreadId?.('');
        setThreadId(newThreadId);
        setShowWelcomeMessage(true);
    }

    const onThreadSelect = (thread: Thread.Data) => {
        setSelectedThreadId(thread.id);
        setThreadId(thread.id);
        setShowWelcomeMessage(false);
    }

    return (
        <AgentContext.Provider value={{ agent, setAgent, threadId, setThreadId, selectedThreadId, setSelectedThreadId, onStartNewThread, onThreadSelect, showWelcomeMessage, setShowWelcomeMessage }}>
            {children}
        </AgentContext.Provider>
    );
}

export const useAgent = ()  => useContext(AgentContext);
